import React from "react";
import "../assets/styles/Footer.scss";

function Footer() {
  return (
    <footer>
      <p>&copy; 2026 Junhan Kim</p>
    </footer>
  );
}

export default Footer;
